import { cineamoApiClient } from '../../apiClient';
import { buildUrlQuery, UrlQueryParameter } from '../../helpers/url-query-helper';
import { CinemaDto } from '../../models/cinema/CinemaDto.types';
import { CinemaContentUpcomingDto } from '../../models/cinema-content-upcoming/CinemaContentUpcomingDto';
import { CinemaContentUpcomingInputDto } from '../../models/cinema-content-upcoming/CinemaContentUpcomingInputDto';
import { ContentDto } from '../../models/content/ContentDto.types';
import { CinemaContentUpcomingListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

import { CinemaContentUpcomingScopeEnum } from './CinemaContentUpcomingScopeEnum.types';

type GetCinemaContentUpcomingsQueryParameter = UrlQueryParameter & {
    releaseDateStart?: string;
    releaseDateEnd?: string;
    scope?: CinemaContentUpcomingScopeEnum[];
};

export async function getCinemaContentUpcomings(
    cinemaId: CinemaDto['id'],
    params?: GetCinemaContentUpcomingsQueryParameter
): Promise<ApiResponse<CinemaContentUpcomingListResponse>> {
    return cineamoApiClient
        .get(`/cinemas/${cinemaId}/cinema-content-upcomings${buildUrlQuery(params)}`)
        .then((response) => response.data)
        .catch(() => null);
}

export async function deleteCinemaContentUpcoming(
    cinemaId: CinemaDto['id'],
    cinemaContentUpcomingId: CinemaContentUpcomingDto['id']
): Promise<boolean> {
    return cineamoApiClient
        .delete(`/cinemas/${cinemaId}/content-upcomings/${cinemaContentUpcomingId}`)
        .then((response) => response.status === 204)
        .catch(() => false);
}

export async function setCinemaContentUpcoming(
    cinemaId: CinemaDto['id'],
    contentId: ContentDto['id'],
    data: CinemaContentUpcomingInputDto
): Promise<ApiResponse<CinemaContentUpcomingDto>> {
    return cineamoApiClient
        .put<ApiResponse<CinemaContentUpcomingDto>>(`/cinemas/${cinemaId}/content-upcomings/${contentId}`, data)
        .then((response) => response.data)
        .catch((error) => error);
}
